import { createSelector } from '@ngrx/store';
import { AppState, selectMainMenuState } from '../../../core/core.state';
import { MainMenuState } from './main-menu.state';

export const selectMenuItems = createSelector(
  selectMainMenuState,
  (state: MainMenuState) => state.menuItems
);
